import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import he from "./locales/he.json";

export type Locale = "en" | "he";

/** Single source of truth for which languages exist, their display name (in their own
 * script — a language switcher shows each option in itself, not translated), and writing
 * direction. `locale-store.ts` and the switcher UI both read this instead of hardcoding it
 * twice. */
export const LOCALES: Record<Locale, { nativeName: string; dir: "ltr" | "rtl" }> = {
  en: { nativeName: "English", dir: "ltr" },
  he: { nativeName: "עברית", dir: "rtl" },
};

void i18next.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    he: { translation: he },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18next;
